import { SHOW_ALERT, HIDE_ALERT ,CLEAR_CONFIRMATION_ALERTS} from "./alertActions";

const initialState = [];

const alertReducer = (state = initialState, action) => {
    switch (action.type) {
        case SHOW_ALERT:
            return [...state, action.payload];

        case HIDE_ALERT:
            return state.filter((alert) => alert.id !== action.payload);
        case CLEAR_CONFIRMATION_ALERTS: // Add this
            return state.filter((alert) => alert.type !== "confirmation");
        default:
            return state;
    }
};

export default alertReducer;